import React from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'react-final-form';
import cn from 'classnames';

import { nonEmptyStringRequired, required } from 'Shared/utils/formValidations';
import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';
import FormInput from 'Shared/components/FormComponents/FormInput';
import FormSelect from 'Shared/components/FormComponents/FormSelect';
import SalesAssistantInstructions from '../SalesAssistantInstructions/SalesAssistantInstructions';
import ChooseAvatarSection from '../ChooseAvatarSection/ChooseAvatarSection';
import UsingWPSection from '../UsingWPSection/UsingWPSection';

import { roleOptions } from '../../../constants';

const customGetOutputValue = value => value;

function ProfileForm() {
  const salesAssistantFlow = useSelector(state => state.onboardingState?.flowType === 'sales_assistant');
  return (
    <div className="profile-form scrollbar pl-1">
      <FieldGroup label="What is your name  & role?" labelClassName="onboarding-form-label">
        <div className="d-flex flex-column flex-sm-row my-3">
          <div className="d-flex flex-column w-100 mr-sm-2">
            <Field
              name="profile.fullName"
              placeholder="Enter full name"
              validate={nonEmptyStringRequired}
              component={FormInput}
              errorLabel={false}
            />

            <Field name="profile.fullName">
              {({ input: { value }, meta: { error, touched } }) => (
                <div className={cn({ visible: error && value, invisible: !error || !value })}>
                  <p className={cn('m-0', { 'text-danger': touched, 'text-muted': !touched })}>
                    Please enter your first and last name
                  </p>
                </div>
              )}
            </Field>
          </div>
          <Field
            name="profile.role"
            placeholder="Choose role..."
            validate={required}
            className="w-100 mt-2 mt-sm-0 align-self-start"
            customGetOutputValue={customGetOutputValue}
            options={roleOptions}
            component={FormSelect}
          />
        </div>
      </FieldGroup>
      <ChooseAvatarSection />
      {!salesAssistantFlow && <UsingWPSection />}
      {salesAssistantFlow && <SalesAssistantInstructions />}
    </div>
  );
}

export default ProfileForm;
